import { render } from "./ps-management-page.vue?vue&type=template&id=269fce50"
import script from "./ps-management-page.ts?vue&type=script&lang=js"
export * from "./ps-management-page.ts?vue&type=script&lang=js"

import "./ps-management-page.scss?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__